// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.crop-title {
    padding: 0;
    margin: 0;
    font-size: 20px;
    font-weight: 600;
}

.crop-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
    gap: 12px;
}

.crop-canvas-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #fafafa;
    border: 1px solid #eee;
    border-radius: 12px;
    padding: 12px;
    min-height: 220px;
}

.crop-zoom-row {
    display: none;
}

.crop-zoom-icon {
    color: #5616ea;
    font-size: 14px;
}

.crop-button-container {
    display: flex;
    justify-content: flex-end;
    gap: 15px;
    margin-top: 20px;
}`, "",{"version":3,"sources":["webpack://./src/components/croppingModal.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,SAAS;IACT,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,SAAS;IACT,gBAAgB;AACpB","sourcesContent":[".crop-title {\r\n    padding: 0;\r\n    margin: 0;\r\n    font-size: 20px;\r\n    font-weight: 600;\r\n}\r\n\r\n.crop-header {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    margin-bottom: 16px;\r\n    gap: 12px;\r\n}\r\n\r\n.crop-canvas-wrapper {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    background-color: #fafafa;\r\n    border: 1px solid #eee;\r\n    border-radius: 12px;\r\n    padding: 12px;\r\n    min-height: 220px;\r\n}\r\n\r\n.crop-zoom-row {\r\n    display: none;\r\n}\r\n\r\n.crop-zoom-icon {\r\n    color: #5616ea;\r\n    font-size: 14px;\r\n}\r\n\r\n.crop-button-container {\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    gap: 15px;\r\n    margin-top: 20px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
